import { cn } from "@/lib/cn";

type Props = {
  className?: string;
  /** When true, hides the wordmark text and only renders the symbol. */
  iconOnly?: boolean;
};

export function WordMark({ className, iconOnly }: Props) {
  return (
    <span className={cn("inline-flex items-center gap-2.5 group", className)}>
      <span
        className={cn(
          "relative grid h-9 w-9 shrink-0 place-items-center overflow-hidden rounded-xl",
          "bg-[#FBF6EC] border border-line/70 shadow-[0_1px_0_rgb(var(--ink)/0.04),0_4px_14px_-8px_rgb(var(--ink)/0.18)]",
          "transition-transform group-hover:-rotate-3 group-hover:scale-105",
        )}
      >
        <img
          src="/assets/images/mobeen-logo.jpg"
          alt="Mobeen Center"
          className="h-7 w-7 object-contain"
          loading="eager"
          decoding="async"
        />
      </span>
      {iconOnly ? null : (
        <span className="font-display text-[22px] font-light leading-none tracking-title text-ink">
          mobeen
          <span className="text-accent">.</span>
        </span>
      )}
    </span>
  );
}
